import { Routes, Route, Navigate } from "react-router-dom";
import CustomerServices from "./CustomerServices";
// import Domestic from "./Domestic";


const customerServicesRoutes = [
    
    {routeName: 'laptop-faqs' , component: <CustomerServices/>},
    {routeName: 'mobile-faqs' , component: <CustomerServices/>},
];

const CustomerServicesRoutes = () => {
    return (
    <Routes>
       {customerServicesRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default CustomerServicesRoutes;